// extracted by mini-css-extract-plugin
export var box = "_4o-1";
export var checked = "_4o-2";
export var descriptionSpacer = "_4o-9";
export var disabled = "_4o-3";
export var icon = "_4o-6";
export var input = "_4o-0";
export var labelSpacer = "_4o-8";
export var medium = "_4o-5";
export var small = "_4o-4";
export var text = "_4o-7";